export const INPUT_CC_NUMBER = 'BILLING/INPUT/CC_NUMBER'
export const INPUT_CC_EXPIRATION_MONTH = 'BILLING/INPUT/CC_EXPIRATION_MONTH'
export const INPUT_CC_EXPIRATION_YEAR = 'BILLING/INPUT/CC_EXPIRATION_YEAR'
export const INPUT_CC_SECURITY_CODE = 'BILLING/INPUT/CC_SECURITY_CODE'
export const INPUT_FIRST_NAME = 'BILLING/INPUT/FIRST_NAME'
export const INPUT_LAST_NAME = 'BILLING/INPUT/LAST_NAME'
export const INPUT_EMAIL_ADDRESS = 'BILLING/INPUT/EMAIL_ADDRESS'
export const INPUT_PHONE_NUMBER = 'BILLING/INPUT/PHONE_NUMBER'
export const INPUT_BILLING_ADDRESS = 'BILLING/INPUT/BILLING_ADDRESS'
export const INPUT_BILLING_COUNTRY = 'BILLING/INPUT/COUNTRY'
export const INPUT_BILLING_ZIP = 'BILLING/INPUT/ZIP'
export const INPUT_BILLING_CITY = 'BILLING/INPUT/CITY'
export const INPUT_BILLING_STATE = 'BILLING/INPUT/STATE'

export const BILLING_STATUS_WAITING = 'BILLING/STATUS/WAITING'
export const BILLING_STATUS_PROCESSING = 'BILLING/STATUS/PROCESSING'
export const BILLING_STATUS_SUCCESS = 'BILLING/STATUS/SUCCESS'
export const BILLING_STATUS_FAILED = 'BILLING/STATUS/FAILED'
